<div class="row">
  <customer-form
    *ngIf="customer"
    [customer]="customer"
    [processing]="processing"
    [languages]="languages"
    [countries]="countries"
    [localEntities]="localEntities"
    (toggleCreateCustomer)="update($event)"
    (toggleCancel)="goToBack()"
  ></customer-form>
</div>
